module.exports = __webpack_public_path__ + "static/media/zalo.9fb21408.svg";